module.exports = __webpack_public_path__ + "img/UTJORD.9490a0d6.png";